import { useContext } from 'react'
import { Box } from '@mui/material'
import CellHOC from 'platform/react/hoc/list/cell'
import ApplicationContext from 'platform/react/context/application'
import Text from '@ui/Element/Text'
import DecoratedLink from 'ui/Element/Button/DecoratedLink'

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    width: '100%',
  },
  link: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
})

/**
 * Display the product image for a given device.
 *
 * @param {Object} classes  styling for the cell
 * @param {Object} props    props for the cell
 *
 * @returns {JSX.Element}
 */
const ListItemCellOrganisationContact = (classes, props = {}) => {
  const { intl } = useContext(ApplicationContext)
  const { name, address, geoMapsLink, service: { phone } = {} } = props
  const addressSummary = intl.address(address, { inline: true })

  return (
    <Box
      className={classes.root}
    >
      <Text
        variant={'14/bold'}
        component={'div'}
      >
        {name}
      </Text>
      <DecoratedLink
        className={classes.link}
        href={geoMapsLink}
        target={'_blank'}
        variant={'14/regular'}
        value={addressSummary}
      />
      <DecoratedLink
        className={classes.link}
        variant={'14/medium'}
        prefix={'tel'}
        value={phone}
      />
    </Box>
  )
}

export default CellHOC(ListItemCellOrganisationContact, styles)
